import { ShowIf, ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { useExperienceHomeConstructedAfterPurchase } from '../../../../fields/ExperienceFields';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

interface ConstructedAfterClosedProps {
    experienceId: string | undefined;
    required?: boolean;
}

export const ConstructedAfterClosed: React.FC<ConstructedAfterClosedProps> = ({ experienceId, required = false }) => {
    const label = 'After you closed on your purchase, was the home constructed? ';
    const [constructedAfterClosed, set_constructedAfterClosed] = useExperienceHomeConstructedAfterPurchase(experienceId);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_constructedAfterClosed(true);
                return;
            case 'no':
                set_constructedAfterClosed(false);
                return;
            default:
                return;
        }
    };

    const eligibilityWarning = (
        <div style={{ color: '#db0007', paddingTop: '1rem', paddingBottom: '1rem' }}>
            <FontAwesomeIcon
                icon={faWarning}
                style={{ paddingRight: '1rem' }}
            />
            This type of experience is not eligible.
        </div>
    );

    const showEligibilityWarning = constructedAfterClosed != undefined && !constructedAfterClosed;

    return (
        <>
            <YesNoToggleButton
                id='toggleButtonConstructedAfterClosed'
                value={constructedAfterClosed}
                onItemClick={toggleButtonYesNoClick}
                width='230px'
                height='40px'
                required={required}
                requiredMessage='This field is required.'
                label={label}
                labelSize={ToggleButtonLabelSize.SmallBold}
            />
            <ShowIf showIf={showEligibilityWarning}>{eligibilityWarning}</ShowIf>
        </>
    );
};
